export const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/** Whether a typed address looks deliverable enough to send; the API makes the final check. */
export const isValidEmail = (email: string): boolean => emailRegex.test(email.trim());
